module.exports = __webpack_public_path__ + "static/media/36.2d5687d3.jpg";